package com.zaurh.portfolio.main

import androidx.compose.material3.Button
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import com.zaurh.portfolio.utils.getPoppinsFont
import kotlinx.browser.window

@Composable
fun CvButton(){
    Button(
        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand),
        colors = ButtonDefaults.buttonColors(
            containerColor = MaterialTheme.colorScheme.tertiary
        ),
        onClick = {
            window.open("/files/zaurhasanov_cv.pdf", "_blank")
        }
    ) {
        Text(
            text = "Download CV",
            fontFamily = getPoppinsFont(),
            color = MaterialTheme.colorScheme.background,
            fontWeight = FontWeight.Bold
        )
    }
}